import type { TopNavSubItem } from './TopNavProps'
import { type TopNavProps } from './TopNavProps'

const defaultHref = '/c/fitness'

const programsSubMenus: TopNavSubItem[] = [
  {
    title: 'Fitness',
    href: defaultHref,
    newTab: true,
    links: [
      {
        title: 'P90X',
        href: defaultHref,
        stamp: 'New!',
      },
      {
        title: '21 Day Fix',
        href: defaultHref,
        stamp: 'New!',
      },
      {
        title: 'Body Beast',
        href: defaultHref,
      },
      {
        title: '80 Day Obsession',
        href: defaultHref,
      },
      {
        title: 'Insanity',
        href: defaultHref,
      },
    ],
  },
  {
    title: 'Eating Plans',
    href: defaultHref,
    links: [
      {
        title: 'The 4 Week Gut Protocol',
        href: defaultHref,
      },
      {
        title: 'Portion Fix',
        href: defaultHref,
      },
      {
        title: '2B Pregnant',
        href: defaultHref,
      },
      {
        title: 'Recipes',
        href: defaultHref,
      },
    ],
  },
  {
    title: 'Hormone Health',
    href: defaultHref,
    links: [
      {
        title: 'Belle Vitale',
        href: defaultHref,
      },
    ],
  },
]

const supplementsSubMenus: TopNavSubItem[] = [
  {
    title: 'Shakeology Daily Nutrition',
    href: defaultHref,
    links: [
      {
        title: 'Original Superfood Shake',
        href: defaultHref,
      },
      {
        title: '0g Added Sugar',
        href: defaultHref,
        stamp: 'New!',
      },
      {
        title: 'Variety Packs',
        href: defaultHref,
      },
      {
        title: 'Sample Packs',
        href: defaultHref,
      },
    ],
  },
  {
    title: 'Sport Nutrition',
    href: defaultHref,
    links: [
      {
        title: 'Energize Pre-Workout',
        href: defaultHref,
      },
      {
        title: 'Recover Post-Workout',
        href: defaultHref,
      },
      {
        title: 'Hydrate Electrolytes',
        href: defaultHref,
      },
    ],
  },
  {
    title: 'Targeted Nutrition',
    href: defaultHref,
    links: [
      {
        title: 'BEACHBAR Snack Bar',
        href: defaultHref,
      },
      {
        title: 'Collagen Peptides',
        href: defaultHref,
      },
      {
        title: 'Last Thing Sleep Aid',
        href: defaultHref,
      },
      {
        title: 'Power Greens Veggies',
        href: defaultHref,
      },
      {
        title: 'Digestive Health Fiber',
        href: defaultHref,
      },
      {
        title: 'Belle Vitale Supplement Duo',
        href: defaultHref,
        stamp: 'New!',
      },
    ],
  },
  {
    title: 'Cleanses',
    href: defaultHref,
    links: [
      {
        title: '3 Day Refresh',
        href: defaultHref,
      },
      {
        title: 'Ultimate Reset',
        href: defaultHref,
      },
    ],
  },
]

const tiles = [
  {
    image:
      'https://res.cloudinary.com/teambeachbody/image/upload/v1727797937/BODi-Merchandising/BODi%20Storefront%2010-22-24/new%20and%20featured/bbp-enr_1125-750-EN.jpg',
    stamp: 'NEW!',
    title: 'Promotional Item',
    alt: 'Image alt',
    href: '/offers',
    newTab: false,
    isVisible: true,
  },
  {
    image:
      'https://res.cloudinary.com/teambeachbody/image/upload/v1727797937/BODi-Merchandising/BODi%20Storefront%2010-22-24/new%20and%20featured/bbp-enr_1125-750-EN.jpg',
    stamp: 'NEW!',
    title: 'Promotional Item',
    alt: 'Image alt',
    href: '/offers',
    newTab: false,
    isVisible: true,
  },
]

export const defaultTopNavProps = {
  logo: {
    href: '/',
    altText: 'Bodi logo',
    src: 'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fbe73d1e15bab4510b776037797f287d3',
    desktopWidth: 99,
    desktopHeight: 32,
    mobileWidth: 76,
    mobileHeight: 24,
  },
  items: [
    {
      title: 'Programs',
      href: defaultHref,
      hasSubItems: true,
      hasCtaMobile: true,
      ctaMobile: {
        title: 'View All Programs',
        href: '/c/fitness',
      },
      ctaDesktop: {
        title: 'Shop Programs',
        href: '/c/fitness',
      },
      subItems: programsSubMenus,
      tiles,
    },
    {
      title: 'Supplements',
      href: defaultHref,
      hasSubItems: true,
      hasCtaMobile: true,
      stamp: 'New!',
      ctaMobile: {
        title: 'Shop Supplements',
        href: '/c/fitness',
      },
      ctaDesktop: {
        title: 'Shop Supplements',
        href: '/c/fitness',
      },
      subItems: supplementsSubMenus,
      tiles,
    },
    {
      hasSubItems: false,
      title: 'App',
      href: defaultHref,
      newTab: true,
    },
  ],
  mobileFooterLinks: [
    {
      title: 'Contact Us / FAQ',
      href: 'https://faq.beachbody.com/app/home?locale=en_US',
      newTab: true,
    },
  ],
  account: {
    signOutCopy: 'Sign out',
    bodiCta: {
      href: '/offers',
      title: 'Get BODi',
    },
    links: [
      {
        title: 'Account Settings',
        href: 'https://www.teambeachbody.com/shop/us/account/settings',
        newTab: true,
      },
      {
        title: 'Orders',
        href: 'https://www.teambeachbody.com/shop/us/account/settings?locale=en_us&tab=MyOrders',
        newTab: true,
      },
      {
        title: 'Subscriptions',
        href: 'https://www.teambeachbody.com/shop/us/account/settings?locale=en_us&tab=membershipsandsubscriptions',
        newTab: true,
      },
    ],
    welcomeCopy: 'Welcome back',
    title: 'Account', // logged in title
    loggedOutTitle: 'Login or Join BODi',
    loggedOutSubtitle: 'Workouts, nutrition, and much more.',
    logInCopy: 'Login',
    loggedInLinks: [
      {
        title: 'BODi App',
        href: 'https://www.beachbodyondemand.com',
        newTab: true,
        subtitle: 'Your workouts, tracking, & more',
        imageAlt: 'BODi logo',
        imageUrl:
          'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F7382a7596e3e48cfb0bc48648db99446?width=200&height=200',
      },
    ],
  },
} satisfies TopNavProps
